var _circle, _circle2, _path, _path2, _path3, _circle3, _ellipse, _ellipse2, _ellipse3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCosmosLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 486 486",
    width: 2500,
    height: 2500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "atom") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 243,
    cy: 243,
    r: 243,
    fill: "#2e3148"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 243,
    cy: 243,
    r: 141,
    fill: "#1b1e36"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M243.5 31c-26.23 0-47.5 95.14-47.5 212.5S217.27 456 243.5 456 291 360.86 291 243.5 269.73 31 243.5 31zm3.28 413c-3 4-6 1-6 1-12.08-14-18.12-40-18.12-40-21.13-68-16.1-214-16.1-214 9.93-115.91 28-143.29 34.14-149.37a3.75 3.75 0 0 1 4.81-.38c8.92 6.32 16.4 32.75 16.4 32.75C284 156 282 233 282 233c2 67-11.07 142-11.07 142-10.06 57-24.15 69-24.15 69z",
    fill: "#6f7390"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M427.82 137.75c-13.06-22.76-106.16 6.14-208 64.55S46.13 326.5 59.18 349.25s106.16-6.14 208-64.55 173.69-124.2 160.64-146.95zM71.22 346.12c-5-.63-3.87-4.74-3.87-4.74C73.48 323.94 93 305.76 93 305.76c48.49-52.17 177.64-120.46 177.64-120.46 105.47-49.07 138.23-47 146.54-44.72a3.75 3.75 0 0 1 2.73 4c-1 10.88-20.25 30.52-20.25 30.52-60.1 60-127.89 96.59-127.89 96.59-57.12 35.09-128.68 61.06-128.68 61.06-54.45 19.62-71.87 13.37-71.87 13.37z",
    fill: "#6f7390"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M427.36 350c13.16-22.7-58.5-88.8-160-147.64S72.79 114.26 59.64 137s58.5 88.8 160.05 147.64 194.52 88.1 207.67 65.36zm-359-204.23c-1.95-4.61 2.16-5.72 2.16-5.72 18.17-3.43 43.69 4.38 43.69 4.38 69.43 15.81 193.23 93.36 193.23 93.36 95.32 66.7 109.94 96.08 112.13 104.42a3.75 3.75 0 0 1-2.08 4.36c-9.94 4.55-36.56-2.23-36.56-2.23-82.05-22-147.67-62.31-147.67-62.31C174.3 250.23 116 201.3 116 201.3c-44.3-37.3-47.62-55.49-47.62-55.49z",
    fill: "#6f7390"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 243,
    cy: 243,
    r: 25,
    fill: "#b7b9c8"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 345.5,
    cy: 147,
    rx: 14.5,
    ry: 15,
    fill: "#b7b9c8"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 107.5,
    cy: 198,
    rx: 14.5,
    ry: 15,
    fill: "#b7b9c8"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 213.5,
    cy: 382,
    rx: 14.5,
    ry: 15,
    fill: "#b7b9c8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCosmosLogo);
export default __webpack_public_path__ + "static/media/cosmos-logo.412ef012.svg";
export { ForwardRef as ReactComponent };